export const regularColor = 'rgb(211, 211, 211, 0.3)';
export const hiddenColor = 'transparent';
